import api from "@/lib/api";

export const orgService = {
  get: () => api.get("/org").then((r) => r.data),
  create: (name) => api.post("/org/create", { name }).then((r) => r.data.org),
  update: (payload) => api.put("/org", payload).then((r) => r.data.org),
  invite: (email) => api.post("/org/invite", { email }).then((r) => r.data.invite),
  join: (code) => api.post("/org/join", { code }).then((r) => r.data),
  cancelInvite: (id) => api.delete(`/org/invites/${id}`).then((r) => r.data),
  removeMember: (id) => api.delete(`/org/members/${id}`).then((r) => r.data),
  setMemberRole: ({ id, role }) => api.post(`/org/members/${id}/role`, { role }).then((r) => r.data),
};
